export default __webpack_public_path__ + "static/media/3d_media.3cf94811.jpg";